<app-action-user [showActionUser]="showActionUser" (showActionUserFalse)="clickShowActionUser(false)"
    (logout)="logout()"></app-action-user>
<app-action-nav [showActionNav]="showActionNav" (showActionNavFalse)="clickShowActionNav(false)"></app-action-nav>

<header>
    <div class="container">
        <div class="logo">
            <a routerLink="/">
                <img src="assets/images/logo.png">
            </a>
        </div>
        <div class="search" [ngClass]="{'search-not-auth': isUserAuth === false}">

            @if(isShowSearch){
            <mat-form-field>
                <input type="text" placeholder="Pesquisa feiradolivro.com.br" aria-label="Number" matInput
                    [formControl]="searchFormControl" [matAutocomplete]="auto" (keyup.enter)="buscar()">
                <button mat-icon-button matSuffix (click)="buscar()" type="button">
                    <mat-icon>search</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
                    @for (option of filteredOptions | async; track option) {
                    <mat-option [value]="option">
                        <div class="autocomplete-option">
                            <img class="autocomplete-option-image" [src]="option.coverUrl" alt="Capa do livro"
                                onerror="this.onerror=null;this.src='https://placehold.co/40x60/e0e0e0/333?text=Capa';">
                            <div class="autocomplete-option-text">
                                <div class="autocomplete-option-title">{{ option.bookTitle }}</div>
                                <div class="autocomplete-option-authors">{{ option.authors.join(', ') }}</div>
                            </div>
                        </div>
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            }

        </div>
        @if(isUserAuth === true){
        <div class="action">
            @if(isShowSearch){
            <a (click)="clickShowActionNav(null)"><span class="material-symbols-outlined">apps</span></a>
            <a (click)="clickShowActionUser(null)"><span class="material-symbols-outlined">account_circle</span></a>
            }

            @if(cartCount > 0){
            <a [routerLink]="'/carrinho'"><span matBadgeOverlap="false" matBadge="{{cartCount}}"
                    class="material-symbols-outlined">shopping_cart</span></a>
            }@else{
            <a [routerLink]="'/carrinho'"><span class="material-symbols-outlined">shopping_cart</span></a>
            }

        </div>
        }@else{
        <div class="action-not-auth">
            <a mat-button class="btn-entrar" (click)="openModalLogin()">Entrar</a>
            <button mat-flat-button class="btn-primary" (click)="openModalRegister()">Começar</button>

            @if(cartCount > 0){
            <a class="cart" [routerLink]="'/carrinho'"><span matBadgeOverlap="false" matBadge="{{cartCount}}"
                    class="material-symbols-outlined">shopping_cart</span></a>
            }@else{
            <a class="cart" [routerLink]="'/carrinho'"><span class="material-symbols-outlined">shopping_cart</span></a>
            }
        </div>
        }
    </div>
</header>

<div class="space-header"></div>